import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SUCCESS_SHOW_DELAY = 300;

interface Props {
  isChecksProcessedAddressPending: boolean;
}

const useReviewSuccess = ({ isChecksProcessedAddressPending }: Props) => {
  const { t } = useTranslation();
  const [isGoPaperlessVisible, setGoPaperlessVisible] = useState(false);
  const [isSuccessVisible, setSuccessVisible] = useState(false);

  const showGoPaperless = useCallback(() => setGoPaperlessVisible(true), []);
  const hideGoPaperless = useCallback(() => setGoPaperlessVisible(false), []);

  const showSuccessWithDelay = useCallback(() => {
    setGoPaperlessVisible(false);
    setTimeout(() => setSuccessVisible(true), SUCCESS_SHOW_DELAY);
  }, []);

  const hideSuccess = useCallback(() => setSuccessVisible(false), []);

  const successTitle = useMemo(
    () => (isChecksProcessedAddressPending ? t("You're almost there!") : t("You're all set!")),
    [isChecksProcessedAddressPending, t]
  );

  const successHelpText = useMemo(
    () =>
      (isChecksProcessedAddressPending
        ? t('Your checks are processed but your address still needs to be updated by your administrator.')
        : undefined),
    [isChecksProcessedAddressPending, t]
  );

  return {
    isGoPaperlessVisible,
    isSuccessVisible,
    successTitle,
    successHelpText,
    showGoPaperless,
    hideGoPaperless,
    showSuccessWithDelay,
    hideSuccess,
  };
};

export default useReviewSuccess;
